export enum DropState {
  EMPTY,
  ALLOW,
  FORBID
}
